import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { Image } from "services/cms/models/image";
import type { Organisation } from "services/cms/models/organisation";
import type { ResolvedImage } from "./imageResolver";
import imageResolver from "./imageResolver";

export interface ResolvedOrganisation {
    description?: string;
    logo?: ResolvedImage;
    name: string;
    type: ContentTypeCodenames.Organisation;
}

const organisationResolver = (data: Organisation): ResolvedOrganisation => {
    const description = data.elements.description.value;
    const logo = data.elements.logo?.linkedItems[0] as Image | undefined;

    const organisation: ResolvedOrganisation = {
        name: data.elements.name.value,
        type: ContentTypeCodenames.Organisation,
    };

    if (description) {
        organisation.description = description;
    }

    if (logo) {
        organisation.logo = imageResolver(logo);
    }

    return organisation;
};

export default organisationResolver;
